export const PORTAL_BODY_CLASS_PREFIXES = [
  "/account",
  "/app-admin",
  "/app-design",
  "/app-testing",
  "/client-resources",
  "/dashboard",
  "/dev-resources",
  "/email-responses",
  "/enquiries",
  "/features",
  "/get-started",
  "/onboarding",
  "/packages",
  "/project",
  "/project-brief",
  "/project-briefs",
  "/projects",
  "/proposal",
  "/proposals",
  "/schedule-call",
  "/stats",
  "/submission-logs",
  "/manage-clients",
] as const;

export function portalBodyClass(path: string): string | undefined {
  const classes: string[] = [];

  if (PORTAL_BODY_CLASS_PREFIXES.some((prefix) => path.startsWith(prefix))) {
    classes.push("enquiries-app", "app-testing");
  }

  if (path.includes("/proposal/preview")) {
    classes.push("proposal-document-preview");
  }

  return classes.length ? classes.join(" ") : undefined;
}

export function applyPortalBodyClass(path: string) {
  if (!import.meta.client) return;

  const nextClass = portalBodyClass(path);
  document.body.classList.remove(
    "enquiries-app",
    "app-testing",
    "proposal-document-preview",
  );

  if (nextClass) {
    for (const className of nextClass.split(" ")) {
      document.body.classList.add(className);
    }
  }
}
